import { borderRadius, getBorder } from '@coachhubio/nova-borders';
import { getBackgroundColor, getColor } from '@coachhubio/nova-colors';
import { Column, Row } from '@coachhubio/nova-flex';
import { paddingY, paddingX, marginBottom, padding, marginEnd, marginX, marginTop, marginY } from '@coachhubio/nova-spaces';
import styled from 'styled-components';

export const preColor = 'primaryDark85';
export const postColor = 'primaryDark70';
export const textsColor = 'text30';

export const GreenBadge = styled(Row)<{ isPositive: boolean }>`
  ${(props) => {
    return getBackgroundColor(props.isPositive ? 'success95' : 'error95');
  }}
  ${(props) => {
    return getColor(props.isPositive ? 'success20' : 'error35');
  }}
  ${borderRadius('xl')}
  ${paddingY('none')}
  ${paddingX('s')}
  ${marginX('none')}
  ${marginY('xs')}
`;
export const BadgeSeparator = styled.div`
  border-radius: 2px;
  height: 64px;
  width: 1px;

  ${getBackgroundColor(preColor)}
`;
export const ColorBoxPre = styled.div`
  border-radius: 4px;
  height: 16px;
  width: 16px;

  ${getBackgroundColor(preColor)}
`;
export const ColorBoxPost = styled.div`
  border-radius: 4px;
  height: 16px;
  width: 16px;

  ${getBackgroundColor(postColor)}
`;

export const ProgressGoalsTable = styled(Column)`
  ${padding('xl')}
  ${marginBottom('5xl')}
  ${getBorder({ color: 'neutral85', width: 's', radius: 'l' })}
  ${getBackgroundColor('neutral')}
  ${borderRadius('l')}
`;
export const BarWrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 250px;
  height: 12px;
  ${getBackgroundColor('neutral97')}
  ${borderRadius('m')}

  &:hover {
    span {
      opacity: 1;
    }
  }
`;
export const BarMarker = styled.div<{ left: number }>`
  position: absolute;
  left: ${(props) => `${props.left * 10}%`};
  transform: translateX(-6px);
  height: 12px;
  width: 12px;

  span {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.2s ease;
    white-space: nowrap;
  }
`;
export const BarPreMarker = styled(BarMarker)<{ isPositive: boolean }>`
  ${getBackgroundColor(preColor)}

  span {
    left: ${(props) => (props.isPositive ? `-24px` : `24px`)};
    ${getColor('text30')}
    font-weight: bold;
  }
`;
export const BarPostMarker = styled(BarMarker)<{ isPositive: boolean }>`
  ${getBackgroundColor(postColor)}

  span {
    left: ${(props) => (props.isPositive ? `24px` : `-24px`)};
    ${getColor('text30')}
    font-weight: bold;
  }
`;
export const BarMarkerDifference = styled.div<{ left: number; right: number; isPositive: boolean }>`
  position: absolute;
  left: ${(props) => (props.isPositive ? `${props.left * 10}%` : `${props.right * 10}%`)};
  right: ${(props) => (props.isPositive ? `${(10 - props.right) * 10}%` : `${(10 - props.left) * 10}%`)};
  height: 12px;
  ${(props) => {
    return getBackgroundColor(props.isPositive ? 'success85' : 'error85');
  }}
`;

const tableWidth = '100%';

export const TableWrapper = styled.div`
  width: ${tableWidth};
`;
export const TableRow = styled(Row)`
  width: 100%;
  ${paddingY('xs')}
`;
export const TableRowWithHover = styled(TableRow)<{ isExpanded: boolean }>`
  cursor: pointer;
  height: 32px;
  ${borderRadius('m')}
  ${(props) => getBackgroundColor(props.isExpanded ? 'primaryDark95' : 'neutral')}

  &:hover {
    ${getBackgroundColor('neutral95')}

    div {
      span {
        font-weight: bold;
      }
    }

    span {
      opacity: 1;
    }
  }
`;
export const TableCellLeft = styled(Column)`
  width: 25%;
  margin-right: 28px;
`;
export const TableCellCenter = styled(Column)`
  width: 60%;
`;
export const TableCellRight = styled(Column)`
  width: 15%;
  margin-left: 28px;
`;

export const ExpandedRow = styled(Row)<{ isExpanded: boolean }>`
  ${borderRadius('m')}
  height: ${({ isExpanded }) => (isExpanded ? '220px' : '0')};
  opacity: ${({ isExpanded }) => (isExpanded ? '1' : '0')};
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  transform-origin: top;
  transform: scaleY(${({ isExpanded }) => (isExpanded ? '1' : '0')});
`;
export const ExpandedLeftColumn = styled(Column)`
  height: 100%;
  width: 48%;
`;
export const ExpandedRightColumn = styled(Column)`
  height: 100%;
  width: 48%;
`;
export const ExpandedBadgeColumn = styled(Column)`
  width: 85%;
  height: 168px;
  ${borderRadius('xl', 'top')}
  ${padding('none')}
  ${marginEnd('none')}
  ${marginTop('s')}
  ${marginBottom('l')}
`;
export const ExpandedBadgeTitleRow = styled(Row)<{ isPre: boolean }>`
  height: 32px;
  ${paddingY('s')}
  ${(props) => getColor(props.isPre ? textsColor : 'neutral')}
  ${(props) => getBackgroundColor(props.isPre ? preColor : postColor)}
  ${borderRadius('m', 'top')}
`;
export const ExpandedBadgeContentRow = styled(Row)`
  height: 112px;
  border: 1px solid lightgray;
  ${borderRadius('m', 'bottom')}
`;
export const ExpandedBadgeFooterRow = styled(Row)`
  height: 24px;
  ${marginTop('xs')}
`;
export const TableRulerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 16px;
`;
export const TableRulerMark = styled.div<{ left: number }>`
  position: absolute;
  left: ${(props) => props.left}%;
  transform: translateX(-50%);
`;
